import {HomePromoCard} from '@apuestes/types'
import {initialHomePromoCardState} from '../../../../_metronic/helpers'
import {createSlice} from '@reduxjs/toolkit'
import {apuestesAPI} from '../../services/apuestesAPI'

const homePromoCardSlice = createSlice({
  name: 'homePromoCard',
  initialState: {
    meta: {fetch: false, id: -1},
    value: initialHomePromoCardState,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addMatcher(apuestesAPI.endpoints.getModelById.matchFulfilled, (state, action) => {
        if (action.meta.arg.originalArgs.model === 'home/promo-cards/bo') {
          state.value = action.payload as unknown as HomePromoCard
        }
      })
      .addMatcher(apuestesAPI.endpoints.updateModel.matchFulfilled, (state, action) => {
        if (action.meta.arg.originalArgs.model === 'home/promo-cards') {
          state.value = action.payload as unknown as HomePromoCard
        }
      })
  },
})

export default homePromoCardSlice.reducer
